<script setup lang="ts">
import { ChangeWithoutSaveDialog, PPageSetting } from '@previo/design-system'
import { computed, ref } from 'vue'
import { useRoute } from 'vue-router'
import router from '~/router'
import { usePropertyModuleStore } from '~/store/property/modules'
import { settingModules } from '~/layouts/components/setting-modules/settingModules'

await usePropertyModuleStore().load()

const route = useRoute()
const hasUnsavedChanges = ref<boolean>(false)
const goToRoute = ref<string | null>(null)
const isChangeWithoutSaveDialogOpen = ref<boolean>(false)

const currentRoute = computed<string>(() => {
  return route.name?.toString() ?? ''
})

const changeRoute = (route: string | null): void => {
  if (!route) {
    return
  }
  if (hasUnsavedChanges.value) {
    goToRoute.value = route
    isChangeWithoutSaveDialogOpen.value = true
  } else {
    router.push({ name: route })
  }
}

const redirectToRoute = (route: string | null): void => {
  if (!route) {
    return
  }
  hasUnsavedChanges.value = false
  isChangeWithoutSaveDialogOpen.value = false
  router.push({ name: route })
}
</script>
<template>
  <p-page-setting
    :modules="settingModules"
    :current-route="currentRoute"
    @go-to-route.prevent="(e, newRoute) => changeRoute(newRoute)"
  >
    <router-view v-model:has-unsaved-changes="hasUnsavedChanges" />
  </p-page-setting>
  <change-without-save-dialog
    v-model="isChangeWithoutSaveDialogOpen"
    :go-to-route="goToRoute"
    @redirect="(newRoute) => redirectToRoute(newRoute)"
  />
</template>
